// extracted by mini-css-extract-plugin
export default {"root":"Wizard-root-5e76acf81d18cc9c8c2de02b886832bf","section":"Wizard-section-dbe58943d327e63e8351dd751a5f6fd2","stepBar":"Wizard-stepBar-d20308c56da27ef4072c21e162250aee"};